import { User, Organization } from "../../../redux/reducers/types";
import { Menu, MenuItem, MenuList } from "./Styles";
import { ProfileAvatar } from "../../Components/ProfileAvatar/ProfileAvatar";
import { Link } from "react-router-dom";
import { BoxNameTitleContainer, UserNameSpan } from "./Styles";
import ClickOutsideHandler from "../../Reusable/ClickOutsideHandler/ClickOutsideHandler";
import SearchSkeletonResults from "./SearchSkeletonResults";
import { SearchResultStyle } from "./Styles";
import { isOrganization } from "../../utils/helper";

const SearchResults = ({
  data,
  isOpenSearchList,
  setIsOpenSearchList,
  handleClickOutside,
  searchLoading,
  searchQuery
}) => {
  if (!isOpenSearchList) return null;

  return (
    <SearchResultStyle>
      <ClickOutsideHandler onClickOutside={handleClickOutside}>
        <Menu>
          <MenuList className={searchLoading ? "search-loading-active" : ""}>
            {searchLoading && (
              <div className="search-loading-center">
                <p className="search-loading-label">Searching...</p>
                <SearchSkeletonResults />
              </div>
            )}
            {!searchLoading &&
              data &&
              Object.keys(data).map((category: string) => (
                <SearchResultItems
                  key={category}
                  data={data[category]}
                  setIsOpenSearchList={setIsOpenSearchList}
                  searchQuery={searchQuery}
                />
              ))}
          </MenuList>
        </Menu>
      </ClickOutsideHandler>
    </SearchResultStyle>
  );
};

const highlightMatch = (text: string, query: string) => {
  if (!query || !text) return text;
  
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // Split the query into individual words
  const queryParts = escapedQuery.split(/\s+/).filter(part => part.length > 0);
  
  // Create a pattern that matches any of the query parts
  const pattern = new RegExp(`(${queryParts.join('|')})`, 'gi');
  
  return text.split(pattern).map((part, index) => 
    queryParts.some(q => part.toLowerCase() === q.toLowerCase()) ? 
    <strong key={index} style={{ fontWeight: 1200, color: 'rgb(238, 90, 41)' }}>{part}</strong> : 
    part
  );
};

export default SearchResults;

const SearchResultItems = ({ data, setIsOpenSearchList, searchQuery }) => {
  return data.map((item: User | Organization) => (
    <MenuItem key={item.id}>
      <Link
        to={
          isOrganization(item)
            ? `/organizations/${item.id}/profile`
            : `/users/${item?.id}`
        }
        onClick={() => setIsOpenSearchList(false)}
      >
        <div className="inner-wrapper">
          <div style={{ marginRight: "12px" }}>
            <ProfileAvatar
              src={item?.image?.url}
              name={
                isOrganization(item)
                  ? `${item.name}`
                  : `${item?.name?.firstName} ${item?.name?.lastName}`
              }
            />
          </div>
          <BoxNameTitleContainer>
            <UserNameSpan>
              {isOrganization(item)
                ? highlightMatch(item.name, searchQuery)
                : <>
                    {highlightMatch(item?.name?.firstName, searchQuery)}{' '}
                    {highlightMatch(item?.name?.lastName, searchQuery)}
                  </>}
            </UserNameSpan>
            <div>
              {isOrganization(item) 
                ? highlightMatch(item.type, searchQuery) 
                : highlightMatch(item.title, searchQuery)}
            </div>
          </BoxNameTitleContainer>
        </div>
      </Link>
    </MenuItem>
  ));
};
